<template>
  <group-details :display-key-owner="false" :display-seats="false" :can-change-group="true" />
</template>

<script>
import GroupDetails from '../../components/access/GroupDetails';

export default {
  name: 'users-management',
  components: {
    GroupDetails
  }
};
</script>

<style scoped>
</style>